import React, { useState, useEffect } from "react";
import api from "../api/api";
import swal from "sweetalert";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa";
import {
  Modal,
  Form,
  Row,
  Col,
  Button,
  Tooltip as BsTooltip,
  OverlayTrigger,
} from "react-bootstrap";
import fao from "../assets/images/fao.png";

import { Line } from "react-chartjs-2";
import Placeholder from "react-bootstrap/Placeholder";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useParams } from "react-router";
import Lottie from "lottie-react";
import warningAnimation from "../assets/images/warnlottie.json";
import "./CropDetails.css";
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);


export default function CropDetails() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [toggle, setToggle] = useState(false);

  const [type, setType] = useState("");
  const [field, setField] = useState("");
  const [zone, setZone] = useState("");
  const [zones, setZones] = useState([]);

  const [fields, setFields] = useState([]);
  const [showKcModal, setShowKcModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [allVarieties, setAllVarieties] = useState([]);
  const [listCrop, setListCrop] = useState([]);
  const [originalState, setOriginalState] = useState({});

  const [cropData, setCropData] = useState({
    cropVariety: "",
    days: "",
    plantingDate: "",
    rootDepth: "",
    density: "",
    ecartInter: "",
    ecartIntra: "",
    ruPratique: "",
    growingDate: "",
    surface: "",
    kc_init: "",
    kc_mid: "",
    kc_late: "",
    init: "",
    dev: "",
    mid: "",
    late: "",
    all_kc: [],
    is_kc_modified: "",

  });

  const [modalMsgType] = useState("info");
  const [SingleCrop, setSingleCrop] = useState({});
  const [validated, setValidated] = useState(false);
  const [farms, setFarms] = useState([]);

  const [isEditingKcPeriod, setIsEditingKcPeriod] = useState(false);
  const params = useParams();
  const [draftData, setDraftData] = useState({});
  const [draftKcData, setDraftKcData] = useState({});

  const totalDays =
    parseInt(draftData.init || 0) +
    parseInt(draftData.dev || 0) +
    parseInt(draftData.mid || 0) +
    parseInt(draftData.late || 0);

  let Uid = JSON.parse(localStorage.getItem("user") || "{}").id;

  let cropUid = params.id;

  const getFieldsByUser = async () => {
    let url = `/admin/user/${Uid}/fields`;

    await api
      .get(url)
      .then((response) => {
        if (response.data.type === "success") {
          let FarmsData = response.data.farms;
          setFarms(FarmsData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getZones = () => {
    let Zones = [];
    farms.map((item) => {
      let fields = item.fields;
      if (fields) {
        fields.map((itemZone) => {
          let zones = itemZone.zones;
          if (zones) {
            zones.map((i) => {
              Zones.push({
                Id: i.id,
                name: i.name,
                Uid: i.uid,
                source: i.source,
                description: i.description,
                field_id: i.field_id,
              });
            });
          }
        });
      }
    });
    setZones(Zones);
  };
  const getFields = () => {
    let Fields = [];
    farms.map((item) => {
      let fields = item.fields;
      if (fields) {
        fields.map((field) => {
          Fields.push({
            title: field.name,
            status: field.status,
            description: field.description,
            Uid: field.uid,
            farm_id: field.farm_id,
            Id: field.id,
          });
        });
      }
    });
    setFields(Fields);
  };

  const getDateLabels = () => {
    if (!cropData.growingDate) return [];

    const labels = [];
    const startDate = new Date(cropData.growingDate);
    const totalDays =
      parseInt(cropData.init || 0) +
      parseInt(cropData.dev || 0) +
      parseInt(cropData.mid || 0) +
      parseInt(cropData.late || 0);
    for (let i = 0; i < totalDays; i++) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + i);
      labels.push(date.toISOString().split("T")[0]);
    }

    return labels;
  };

  const chartData = {
    labels: getDateLabels(),
    datasets: [
      {
        label: "Kc",
        data: cropData?.all_kc?.map((item) => parseFloat(item.kc)),
        fill: false,
        pointRadius: 0,
        borderColor: "#26a6b7",
        tension: 0.3,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: t('Kc_Evolution_by_Day')
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Days",
        },
      },
      y: {
        title: {
          display: true,
          text: "Kc",
        },
        min: 0,
        max: 1.2,
      },
    },
  };
  const getVarieties = async () => {
    try {
      await api
        .get("/varieties/get-varieties")
        .then((response) => {
          if (response.data.type === "success") {
            let listVarieties = response.data.Varieties;
            setAllVarieties(listVarieties);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const getCropType = async () => {
    try {
      await api.get("/croptype/list-crop").then((response) => {
        if (response) {
          let dataCrop = response.data.Croptype;
          setListCrop(dataCrop);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getSingleCrop = () => {
    let data = {
      crop_uid: cropUid,
    };
    return api
      .post("/crop", data)
      .then((res) => {
          let CropData = res.data.crop;

          let variety = CropData.varieties || {};
          let croptype = CropData.croptypes || {};

          const values = [
            "kc_init",
            "kc_mid",
            "kc_late",
            "init",
            "dev",
            "mid",
            "late",
            "all_kc",
          ];

          const isValid = (val) =>
            val !== undefined && val !== null && val !== "";
          const allCropDataFieldsValid = values.every((field) =>
            isValid(CropData?.[field])
          );

          const allVarietyFieldsValid = values.every((field) =>
            isValid(variety?.[field])
          );

          const source = allCropDataFieldsValid
            ? CropData
            : allVarietyFieldsValid
            ? variety
            : croptype;

          const fallbackValues = {};

          for (const field of values) {
            fallbackValues[field] = isValid(source?.[field])
              ? source[field]
              : "";
          }

          setSingleCrop(CropData);
          setType(CropData.croptype_id);

          setCropData({
            cropVariety: CropData.crop_variety_id,
            days: CropData.days,
            croptype_id: CropData.croptype_id,
            plantingDate: CropData.plantingDate,
            rootDepth: CropData.rootDepth,
            density: CropData.density,
            ecartInter: CropData.ecart_inter,
            ecartIntra: CropData.ecart_intra,
            ruPratique: CropData.practical_fraction,
            growingDate: CropData.growingDate,
            field_uid: CropData.field_id,
            surface: CropData.surface,
            ...fallbackValues,
            is_kc_modified: CropData.is_kc_modified,
          });
          setOriginalState({
            field: field,
            zone: zone,
            type: CropData.croptype_id,
            cropData: {
              cropVariety: CropData.crop_variety_id,
              days: CropData.days,
              croptype_id: CropData.croptype_id,
              plantingDate: CropData.plantingDate,
              rootDepth: CropData.rootDepth,
              density: CropData.density,
              ecartInter: CropData.ecart_inter,
              ecartIntra: CropData.ecart_intra,
              ruPratique: CropData.practical_fraction,
              growingDate: CropData.growingDate,
              surface: CropData.surface,
              ...fallbackValues,
              is_kc_modified: CropData.is_kc_modified,
            },
          });
      })
      .catch((error) => {
        console.error(error);
        swal({
          title: t("Error"),
          icon: "error",
        });
      })
      .finally(() => {
        setValidated(false);
        setToggle((prev) => !prev);
      });
  };

  useEffect(() => {
    getFieldsByUser();
  }, []);

  useEffect(() => {
    getFields();

    getZones();
  }, [farms]);

  useEffect(() => {
    if (!cropUid) return;

    setIsLoading(true);

    Promise.all([getCropType(), getVarieties(), getSingleCrop()])
      .catch((error) => {
        console.error("Error loading crop data:", error);
      })
      .finally(() => {
        setTimeout(() => setIsLoading(false), 300);
      });
  }, [cropUid]);

  useEffect(() => {
    if (!SingleCrop || (fields.length === 0 && zones.length === 0)) return;

    fields.forEach((fieldData) => {
      if (SingleCrop.field_id == fieldData.Id) {
        setField(fieldData.Uid);
      }
    });
    zones.forEach((zoneData) => {
      if (SingleCrop.zone_id === zoneData.Id) {
        setZone(zoneData.Uid);
      }
    });
  }, [fields, zones, SingleCrop]);

  const tableConfigKc = () => {
    let results = [];

    const init = parseInt(cropData.init);
    const dev = parseInt(cropData.dev);
    const mid = parseInt(cropData.mid);
    const late = parseInt(cropData.late);

    const kcInit = parseFloat(cropData.kc_init);
    const kcMid = parseFloat(cropData.kc_mid);

    const kcLate = parseFloat(cropData.kc_late);

    let totalDays = init + dev + mid + late;

    for (let day = 1; day <= totalDays; day++) {
      let kc = 0;

      if (day <= init) {
        kc = kcInit;
      } else if (day <= init + dev) {
        const j = day - init;
        kc = kcInit + ((kcMid - kcInit) / dev) * j;
      } else if (day <= init + dev + mid) {
        kc = kcMid;
      } else if (day <= init + dev + mid + late) {
        const j = day - (init + dev + mid);
        kc = kcMid - ((kcMid - kcLate) / late) * j;
      }

      kc = parseFloat(kc.toFixed(2));
      results.push({ day, kc });
    }

    return { results };
  };

  useEffect(() => {
    if (
      cropData.init &&
      cropData.dev &&
      cropData.mid &&
      cropData.late &&
      cropData.kc_init &&
      cropData.kc_mid &&
      cropData.kc_late
    ) {
      const { results } = tableConfigKc();

      setCropData((prev) => ({
        ...prev,
        all_kc: results,
      }));
    }
  }, [
    cropData.init,
    cropData.dev,
    cropData.mid,
    cropData.late,
    cropData.kc_init,
    cropData.kc_mid,
    cropData.kc_late,
  ]);

  const handleEdit = async (cropUid) => {
    const fieldId = cropData.field_uid;
    let data = {
      croptype_id: type,
      crop_variety_id: cropData.cropVariety,
      days:
        parseInt(cropData.init || 0) +
        parseInt(cropData.dev || 0) +
        parseInt(cropData.mid || 0) +
        parseInt(cropData.late || 0),
      plantingDate: cropData.plantingDate,
      rootDepth: cropData.rootDepth,
      crop_uid: cropUid,
      field_uid: field,
      zone_uid: zone,
      practical_fraction: cropData.ruPratique,
      density: cropData.density,
      ecart_inter: cropData.ecartInter,
      ecart_intra: cropData.ecartIntra,
      growingDate: cropData.growingDate,
      surface: cropData.surface,
      kc_init: cropData.kc_init,
      kc_mid: cropData.kc_mid,
      kc_late: cropData.kc_late,
      init: cropData.init,
      dev: cropData.dev,
      mid: cropData.mid,
      late: cropData.late,
      all_kc: cropData.all_kc,
      is_modified: cropData.is_kc_modified,
    };

    try {
      const response = await api.post("/crop/edit-crop", data);
      if (response.data.type === "success") {
        const calculation = response.data.calculation;
        const calculationCreated = Array.isArray(calculation?.data) && calculation.data.length > 0;
        const reasonLabels = {
          NO_ACTIVE_SEASON: "Aucune saison active",
          MULTIPLE_ACTIVE_SEASONS: "Plusieurs saisons actives",
          SEASON_START_MISSING_OR_INVALID: "Date de début absente ou invalide",
          SEASON_START_IN_FUTURE: "La saison n'a pas encore commencé",
          SEASON_ALREADY_ENDED: "La saison est déjà terminée",
          CROP_DURATION_INVALID: "Durée de culture invalide",
          KC_DATA_MISSING: "Courbe Kc manquante",
          KC_DATA_INVALID: "Courbe Kc présente mais format invalide",
          KC_DATA_TOO_SHORT: "Courbe Kc incomplète",
          SOIL_RUMAX_MISSING: "RU max du sol manquant",
          FIELD_LOCATION_MISSING: "Coordonnées du champ manquantes",
          IRRIGATION_CONFIGURATION_MISSING: "Configuration d'irrigation manquante",
          WEATHER_DATA_MISSING: "Données météo indisponibles",
        };
        const reasons = (calculation?.feedback || [])
          .flatMap((item) => item.reasons || [])
          .map((reason) => reasonLabels[reason] || reason);

        swal({
          title: t("crop_updated"),
          text: calculationCreated
            ? "La culture a été enregistrée et le calcul a réussi."
            : reasons.length
              ? `La culture est enregistrée. Calcul impossible : ${[...new Set(reasons)].join(" • ")}`
              : "La culture est enregistrée, mais aucun résultat de calcul n'a été créé.",
          icon: calculationCreated ? "success" : "warning",
        });
        setToggle(false);
      } else {
        swal({ icon: "error", title: t("Oops..."), text: t("Crop update failed") });
      }
    } catch (error) {
      swal({
        icon: "error",
        title: t("Oops..."),
        text: t("Crop update error"),
      });
      console.error(error);
    }
  };
  const isValid = (val) => val !== "" && val != null;

  const getDefaultKcAndPeriods = () => {
    const selectedVariety = allVarieties.find(
      (v) => v.id == cropData.cropVariety
    );
    const selectedCropType = listCrop.find((crop) => crop.id == type);
    const fields = [
      "kc_init",
      "kc_mid",
      "kc_late",
      "init",
      "dev",
      "mid",
      "late",
    ];

    // Check if ALL fields in variety are valid
    const allVarietyFieldsValid = fields.every((field) =>
      isValid(selectedVariety?.[field])
    );

    const source = allVarietyFieldsValid ? selectedVariety : selectedCropType;

    const result = {};

    for (const field of fields) {
      result[field] = isValid(source?.[field]) ? source[field] : "";
    }

    return result;
  };

  const checkIfModified = (current, defaults) => {
    return (
      parseFloat(current.kc_init) !== parseFloat(defaults.kc_init) ||
      parseFloat(current.kc_mid) !== parseFloat(defaults.kc_mid) ||
      parseFloat(current.kc_late) !== parseFloat(defaults.kc_late) ||
      parseInt(current.init) !== parseInt(defaults.init) ||
      parseInt(current.dev) !== parseInt(defaults.dev) ||
      parseInt(current.mid) !== parseInt(defaults.mid) ||
      parseInt(current.late) !== parseInt(defaults.late)
    );
  };

  useEffect(() => {
    const canCheck = type && allVarieties.length >= 0 && listCrop.length > 0;

    if (canCheck) {
      const defaults = getDefaultKcAndPeriods();
      const modified = checkIfModified(cropData, defaults);

      if (cropData.is_kc_modified !== modified) {
        setCropData((prev) => ({
          ...prev,
          is_kc_modified: modified,
        }));
      }
    }
  }, [
    cropData.cropVariety,
    type,
    allVarieties,
    listCrop,
    cropData.kc_init,
    cropData.kc_mid,
    cropData.kc_late,
    cropData.init,
    cropData.dev,
    cropData.mid,
    cropData.late,
  ]);

  const handleVarietyChange = (selectedVarietyId) => {
    const selectedVariety = allVarieties.find((v) => v.id == selectedVarietyId);
    const selectedCropType = listCrop.find((c) => c.id == type);

    const isValid = (val) => val !== "" && val != null;

    const fields = [
      "kc_init",
      "kc_mid",
      "kc_late",
      "init",
      "dev",
      "mid",
      "late",
    ];

    // Check if ALL fields in variety are valid
    const allVarietyFieldsValid = fields.every((field) =>
      isValid(selectedVariety?.[field])
    );

    const source = allVarietyFieldsValid ? selectedVariety : selectedCropType;

    const defaults = {};

    for (const field of fields) {
      defaults[field] = isValid(source?.[field]) ? source[field] : "";
    }

    const isModified =
      cropData.is_kc_modified === true ||
      cropData.is_kc_modified === "1" ||
      cropData.is_kc_modified === 1;

    if (isModified) {
      swal({
        title: t("overwrite_kc_title") || "Overwrite values?",
        text:
          t("overwrite_kc_message") ||
          "You have modified Kc or period values. Do you want to replace them with defaults from the selected variety?",
        icon: "warning",
        buttons: [
          t("no_keep_my_values") || "Keep Current",
          t("yes_use_defaults") || "Use Defaults",
        ],
        dangerMode: true,
      }).then((willOverwrite) => {
        if (willOverwrite) {
          setCropData((prev) => ({
            ...prev,
            cropVariety: selectedVarietyId,
            ...defaults,
            is_kc_modified: false,
          }));
        } else {
          setCropData((prev) => ({
            ...prev,
            cropVariety: selectedVarietyId,
          }));
        }
      });
    } else {
      setCropData((prev) => ({
        ...prev,
        cropVariety: selectedVarietyId,
        ...defaults,
        is_kc_modified: false,
      }));
    }
  };

  const isCurveReady = () => {
    return (
      cropData.growingDate &&
      cropData.kc_init &&
      cropData.kc_mid &&
      cropData.kc_late &&
      cropData.init &&
      cropData.dev &&
      cropData.mid &&
      cropData.late
    );
  };

  const isChanged = () => {
    return (
      field !== originalState.field ||
      zone !== originalState.zone ||
      type !== originalState.type ||
      cropData.cropVariety !== originalState.cropData?.cropVariety ||
      String(cropData.kc_init) !== String(originalState.cropData?.kc_init) ||
      String(cropData.kc_mid) !== String(originalState.cropData?.kc_mid) ||
      String(cropData.kc_late) !== String(originalState.cropData?.kc_late) ||
      String(cropData.init) !== String(originalState.cropData?.init) ||
      String(cropData.dev) !== String(originalState.cropData?.dev) ||
      String(cropData.mid) !== String(originalState.cropData?.mid) ||
      String(cropData.late) !== String(originalState.cropData?.late) ||
      cropData.plantingDate !== originalState.cropData?.plantingDate ||
      cropData.rootDepth !== originalState.cropData?.rootDepth ||
      cropData.density !== originalState.cropData?.density ||
      cropData.ecartInter !== originalState.cropData?.ecartInter ||
      cropData.ecartIntra !== originalState.cropData?.ecartIntra ||
      cropData.ruPratique !== originalState.cropData?.ruPratique ||
      cropData.growingDate !== originalState.cropData?.growingDate ||
      cropData.surface !== originalState.cropData?.surface ||
      cropData.days !== originalState.cropData?.days
    );
  };
  const defaults = getDefaultKcAndPeriods();
  const isPeriodModified =
    draftData.init !== defaults.init ||
    draftData.dev !== defaults.dev ||
    draftData.mid !== defaults.mid ||
    draftData.late !== defaults.late;

  const isKcsModified =
    draftData.kc_init !== defaults.kc_init ||
    draftData.kc_mid !== defaults.kc_dev ||
    draftData.kc_late !== defaults.kc_late;
  return (
    <main className="crop-edit-page">
      {isLoading ? (
        <div className="crop-edit-card">
          <Placeholder
            animation="wave"
            className="w-100 rounded"
          >
            <div className="mb-4">
              <Placeholder
                xs={4}
                className="w-100 rounded"
                style={{ backgroundColor: "#e5ebef", height: "20px" }}
              />
              <Placeholder
                className="w-100 rounded mt-2"
                style={{ backgroundColor: "#e8f7f9", height: "38px" }}
              />
            </div>

            {[...Array(4)].map((_, index) => (
              <Row className="mb-4 gap-2 justify-content-between" key={index}>
                <Col md={4}>
                  <Placeholder
                    xs={6}
                    className="w-100 rounded"
                    style={{ backgroundColor: "#e5ebef", height: "20px" }}
                  />
                  <Placeholder
                    className="w-100 rounded mt-2"
                    style={{ backgroundColor: "#e8f7f9", height: "38px" }}
                  />
                </Col>
                <Col md={3}>
                  <Placeholder
                    xs={6}
                    className="w-100 rounded"
                    style={{ backgroundColor: "#e5ebef", height: "20px" }}
                  />
                  <Placeholder
                    className="w-100 rounded mt-2"
                    style={{ backgroundColor: "#e8f7f9", height: "38px" }}
                  />
                </Col>
                <Col md={4}>
                  <Placeholder
                    xs={6}
                    className="w-100 rounded"
                    style={{ backgroundColor: "#e5ebef", height: "20px" }}
                  />
                  <Placeholder
                    className="w-100 rounded mt-2"
                    style={{ backgroundColor: "#e8f7f9", height: "38px" }}
                  />
                </Col>
              </Row>
            ))}

            <div className="d-flex justify-content-end mt-4">
              <Placeholder.Button
                xs={2}
                style={{ backgroundColor: "#e8f7f9" }}
              />
            </div>
          </Placeholder>
        </div>
      ) : (
        <Form
          className="crop-edit-form"
          noValidate
          validated={validated}
          onSubmit={(e) => {
            e.preventDefault();
            const form = e.currentTarget;

            if (form.checkValidity() === false) {
              e.stopPropagation();
              setValidated(true);
            } else {
              handleEdit(SingleCrop.uid);
            }
          }}
        >
          <div className="crop-edit-toolbar">
            <h6
              onClick={() => navigate("/AddField")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate("/AddField"); }}
              className="crop-edit-back d-flex align-items-center"
            >
              <FaArrowLeft aria-hidden="true" style={{ cursor: "pointer", marginRight: "10px" }} />
              {t("edit_crop")}
            </h6>

            <div className="crop-edit-actions">
              <OverlayTrigger
                placement="top"
                overlay={
                  !isChanged() ? (
                    <BsTooltip id="tooltip-disabled">
                      {t("make change to enable")}
                    </BsTooltip>
                  ) : (
                    <></>
                  )
                }
              >
                <span
                  style={{
                    display: "inline-block",
                    position: "relative",
                  }}
                >
                  <Button
                    size="lg"
                    className="mb-0"
                    variant="success"
                    type="submit"
                    disabled={!isChanged()}
                    style={{
                      pointerEvents: !isChanged() ? "none" : "auto",
                    }}
                  >
                    {t("save")} <i className="fa fa-check mx-2" aria-hidden="true" />
                  </Button>
                </span>
              </OverlayTrigger>
            </div>
          </div>
          <div>
            <Row form className="gap-2 mb-5">
              <Col lg="4" md="12" sm="12" className="form-group">
                <p className="crop-edit-field-label">{t("name_field")}</p>
                <Form.Select
                  id="crop-field"
                  aria-label={t("name_field")}
                  value={field}
                  onChange={(e) => setField(e.target.value)}
                >
                  {fields.map((fieldOption) => (
                    <option key={fieldOption.Uid} value={fieldOption.Uid}>{fieldOption.title}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col lg="3" md="12" sm="12" className="form-group">
                <p className="crop-edit-field-label">{t("name_zone")}</p>
                <Form.Select
                  id="crop-zone"
                  aria-label={t("name_zone")}
                  value={zone}
                  onChange={(e) => setZone(e.target.value)}
                >
                  {zones.map((zoneOption) => (
                    <option key={zoneOption.Uid} value={zoneOption.Uid}>{zoneOption.name}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col lg="4" md="12" sm="12" className="form-group">
                <p className="crop-edit-field-label">{t("crop_type")}</p>
                <Form.Select
                  id="crop-type"
                  aria-label={t("crop_type")}
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                    const selectedCrop = listCrop.find(
                      (crop) => crop.id == e.target.value
                    );
                    if (selectedCrop) {
                      setCropData((prev) => ({
                        ...prev,
                        cropVariety: "",
                        kc_init: selectedCrop.kc_init || "",
                        kc_mid: selectedCrop.kc_mid || "",
                        kc_late: selectedCrop.kc_late || "",
                        init: selectedCrop.init || "",
                        dev: selectedCrop.dev || "",
                        mid: selectedCrop.mid || "",
                        late: selectedCrop.late || "",
                      }));
                    }
                  }}
                >
                  {listCrop.map((crop) => {
                    return <option key={crop.id} value={crop.id}>{crop.crop}</option>;
                  })}
                </Form.Select>
                <div className="invalid-feedback">{t("no_empty")}</div>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <p className="crop-edit-field-label">{t("crop_variety")}</p>

                  <Form.Select
                    value={cropData.cropVariety}
                    id="cropVariety"
                    onChange={(e) => handleVarietyChange(e.target.value)}
                  >
                    <option value="">{t("crop_type")}</option>

                    {allVarieties
                      .filter((variety) => variety.crop_id == type)
                      .map((variety) => (
                        <option key={variety.id} value={variety.id}>
                          {variety.crop_variety}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg="3" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-surface" className="crop-edit-field-label">{t("surface")} (m²)</Form.Label>
                  <Form.Control
                    id="crop-surface"
                    type="number"
                    value={cropData.surface}
                    onChange={(e) =>
                      setCropData({ ...cropData, surface: e.target.value })
                    }
                    placeholder={t("surface")}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-root-depth" className="crop-edit-field-label">{t("profondeur")} (m)</Form.Label>
                  <Form.Control
                    id="crop-root-depth"
                    type="number"
                    value={cropData.rootDepth}
                    onChange={(e) =>
                      setCropData({ ...cropData, rootDepth: e.target.value })
                    }
                    placeholder={t("profondeur")}
                  />
                </Form.Group>
              </Col>

              <Col lg="3" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-planting-date" className="crop-edit-field-label">{t("planting_date")}</Form.Label>
                  <Form.Control
                    id="crop-planting-date"
                    type="date"
                    value={cropData.plantingDate}
                    onChange={(e) =>
                      setCropData({
                        ...cropData,
                        plantingDate: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-growing-date" className="crop-edit-field-label">{t("growing_season")}</Form.Label>
                  <Form.Control
                    id="crop-growing-date"
                    type="date"
                    value={cropData.growingDate}
                    onChange={(e) =>
                      setCropData({
                        ...cropData,
                        growingDate: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-ru-pratique" className="crop-edit-field-label">{t("fraction_pratique")} (%) </Form.Label>
                  <Form.Control
                    id="crop-ru-pratique"
                    type="number"
                    value={cropData.ruPratique}
                    onChange={(e) =>
                      setCropData({ ...cropData, ruPratique: e.target.value })
                    }
                    placeholder={t("fraction_pratique")}
                  />
                </Form.Group>
              </Col>
              <Col lg="3" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-ecart-inter" className="crop-edit-field-label">{t("ecart_inter")} (m)</Form.Label>
                  <Form.Control
                    id="crop-ecart-inter"
                    type="number"
                    value={cropData.ecartInter}
                    onChange={(e) =>
                      setCropData({ ...cropData, ecartInter: e.target.value })
                    }
                    placeholder={t("ecart_inter")}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-ecart-intra" className="crop-edit-field-label">{t("ecart_intra")} (m) </Form.Label>
                  <Form.Control
                    id="crop-ecart-intra"
                    type="number"
                    value={cropData.ecartIntra}
                    onChange={(e) =>
                      setCropData({ ...cropData, ecartIntra: e.target.value })
                    }
                    placeholder={t("ecart_intra")}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label htmlFor="crop-density" className="crop-edit-field-label">{t("densité")}</Form.Label>
                  <Form.Control
                    id="crop-density"
                    type="number"
                    value={cropData.density}
                    onChange={(e) =>
                      setCropData({ ...cropData, density: e.target.value })
                    }
                    placeholder={t("densité")}
                  />
                </Form.Group>
              </Col>
            </Row>

            {Number(cropData.is_kc_modified) === 1 ? (
              <div
                className={`crop-edit-alert ${modalMsgType === "info" ? "is-warning" : "is-warning"}`}
                role="status"
              >
                <i className="fa fa-info-circle" aria-hidden="true" />
                <div>{t("kc_modified_warning")}</div>
              </div>
            ) : (
              <div className="crop-edit-fao-banner">
                <img src={fao} alt="FAO" />
                <p>
                  {t("kc_defaults_info")}
                  <strong style={{ color: "var(--crop-heading)" }}> {t("fao_full_name")}</strong>.
                </p>
              </div>
            )}

            <h6 className="crop-edit-section-title">{t("kc_values")}</h6>

            <div className="crop-edit-panel">
              <div className="crop-edit-kc-summary">
                <span>
                  Kc<sub>{t("init")}</sub>: <strong>{cropData.kc_init}</strong>
                </span>
                <span>
                  Kc<sub>{t("mid")}</sub>: <strong>{cropData.kc_mid}</strong>
                </span>
                <span>
                  Kc<sub>{t("late")}</sub>: <strong>{cropData.kc_late}</strong>
                </span>
              </div>
              <div className="crop-edit-actions-end mt-3">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  type="button"
                  onClick={() => {
                    setDraftKcData({
                      kc_init: cropData.kc_init,
                      kc_mid: cropData.kc_mid,
                      kc_late: cropData.kc_late,
                    });
                    setShowKcModal(true);
                  }}
                >
                  {t("modify") || "Modify"}
                </Button>
              </div>
            </div>

            <h6 className="crop-edit-section-title">{t("crop_development")}</h6>

            <div className="crop-edit-panel mb-5">
              {isEditingKcPeriod ? (
                <>
                  <div className="crop-edit-alert is-warning" role="alert">
                    {t("kc_warning") ||
                      "⚠️ Changing crop period values will directly affect water requirement calculations. Proceed only if you accept full responsibility for these modifications."}
                  </div>
                  <Row className="mb-2 gap-3 justify-content-between">
                    <Form.Group as={Col} md="3">
                      <Form.Label htmlFor="crop-period-init">{t("initial_period")} </Form.Label>
                      <Form.Control
                        id="crop-period-init"
                        type="number"
                        placeholder={`${t("e_g")} 20`}
                        value={draftData.init}
                        required
                        min="1"
                        onChange={(e) =>
                          setDraftData({ ...draftData, init: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label htmlFor="crop-period-dev">{t("development_period")} </Form.Label>
                      <Form.Control
                        id="crop-period-dev"
                        type="number"
                        placeholder={`${t("e_g")} 35`}
                        value={draftData.dev}
                        required
                        min="1"
                        onChange={(e) =>
                          setDraftData({ ...draftData, dev: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label htmlFor="crop-period-mid">{t("mid_period")} </Form.Label>
                      <Form.Control
                        id="crop-period-mid"
                        type="number"
                        placeholder={`${t("e_g")} 40`}
                        value={draftData.mid}
                        required
                        min="1"
                        onChange={(e) =>
                          setDraftData({ ...draftData, mid: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="2">
                      <Form.Label htmlFor="crop-period-late">{t("late_period")} </Form.Label>
                      <Form.Control
                        id="crop-period-late"
                        type="number"
                        placeholder={`${t("e_g")} 25`}
                        value={draftData.late}
                        required
                        min="1"
                        onChange={(e) =>
                          setDraftData({ ...draftData, late: e.target.value })
                        }
                      />
                    </Form.Group>

                    {totalDays > 365 && (
                      <p className="crop-edit-alert is-danger" role="alert">
                        {t(
                          "The total duration should not exceed 365 days. Currently:"
                        )}{" "}
                        {totalDays} {t("days")}
                      </p>
                    )}
                    <Col
                      md="12"
                      className="d-flex justify-content-end gap-2 mt-3"
                    >
                      <Button
                        variant="outline-secondary"
                        disabled={!isPeriodModified}
                        onClick={() => {
                          setDraftData({ ...defaults });
                        }}
                      >
                        {t("reset_period")}
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={() => setIsEditingKcPeriod(false)}
                      >
                        {t("cancel")}
                      </Button>
                      <Button
                        variant="success"
                        type="button"
                        onClick={() => {
                          const total =
                            parseInt(draftData.init || 0) +
                            parseInt(draftData.dev || 0) +
                            parseInt(draftData.mid || 0) +
                            parseInt(draftData.late || 0);
                          if (total > 365) {
                            swal({
                              icon: "warning",
                              title: t("Too many days"),
                              text: t(
                                "The total duration of kc periods exceeds 365 days. Please correct them."
                              ),
                            });
                            return;
                          }

                          setCropData((prev) => ({
                            ...prev,
                            init: draftData.init,
                            dev: draftData.dev,
                            mid: draftData.mid,
                            late: draftData.late,
                            is_kc_modified: checkIfModified(
                              draftData,
                              getDefaultKcAndPeriods()
                            ),
                          }));

                          setIsEditingKcPeriod(false);
                        }}
                      >
                        {t("save")}
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <div className="crop-edit-period-summary">
                    <span><strong>{t("initial_period")} :</strong> {cropData.init}</span>
                    <span><strong>{t("development_period")} :</strong> {cropData.dev}</span>
                    <span><strong>{t("mid_period")} :</strong> {cropData.mid}</span>
                    <span><strong>{t("late_period")} :</strong> {cropData.late}</span>
                  </div>

                  <hr />

                  <div className="crop-edit-total-duration">
                    <strong>{t("Total_Growth_Duration")}</strong>
                    <span>
                      :{" "}
                      {parseInt(cropData.init || 0) +
                        parseInt(cropData.dev || 0) +
                        parseInt(cropData.mid || 0) +
                        parseInt(cropData.late || 0)}{" "}
                      {t("days") || "days"}
                    </span>
                  </div>
                  <div className="crop-edit-actions-end">
                    <Button
                      variant="outline-secondary"
                      type="button"
                      size="sm"
                      onClick={() => {
                        setDraftData({
                          init: cropData.init,
                          dev: cropData.dev,
                          mid: cropData.mid,
                          late: cropData.late,
                        });
                        setIsEditingKcPeriod(true);
                      }}
                    >
                      {t("modify") || "Modify"}
                    </Button>
                  </div>
                </>
              )}
            </div>

            <h6 className="crop-edit-section-title">
              {t("kc_curve_info") ||
                "The Kc curve below is automatically generated based on the growing season, Kc values (kc_init, kc_mid, kc_late), and crop development periods (initial, development, mid, late)."}
            </h6>

            <div className="crop-edit-chart-wrap">
              <div
                className="crop-edit-chart-inner"
                style={{ filter: isCurveReady() ? "none" : "blur(1px)" }}
              >
                <Line data={chartData} options={chartOptions} />
              </div>

              {!isCurveReady() && (
                <div className="crop-edit-chart-overlay">
                  {t("kc_curve_message")}
                </div>
              )}
            </div>
          </div>
        </Form>
      )}
      <Modal
        show={showKcModal}
        onHide={() => setShowKcModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Lottie
                animationData={warningAnimation}
                loop
                autoplay
                style={{ height: 60, width: 60 }}
              />
              <span>{t("modify_kc_values")}</span>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="d-flex flex-column justify-content-center">
          <p className="crop-edit-kc-warning-text">
            <Trans i18nKey="kc_warning_text">
              These Kc values are based on <strong>FAO recommendations</strong>.
              Modifying them may <strong>significantly impact</strong> water requirement
              calculations and <strong>irrigation planning</strong>. Proceed only if you
              accept <strong>full responsibility</strong>.
            </Trans>
          </p>
          <Form>
            <Row className="mb-3 mt-3 gap-2 justify-content-between">
              <Form.Group as={Col} md="4">
                <Form.Label htmlFor="crop-kc-init">{t("kc_init")}</Form.Label>
                <Form.Control
                  id="crop-kc-init"
                  type="number"
                  step="0.01"
                  placeholder={`${t("e_g")} 0.30`}
                  value={draftKcData.kc_init}
                  required
                  min="0.01"
                  onChange={(e) =>
                    setDraftKcData({ ...draftKcData, kc_init: e.target.value })
                  }
                />
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label htmlFor="crop-kc-mid">{t("kc_mid")}</Form.Label>
                <Form.Control
                  id="crop-kc-mid"
                  type="number"
                  step="0.01"
                  placeholder={`${t("e_g")} 1.15`}
                  required
                  min="0.01"
                  value={draftKcData.kc_mid}
                  onChange={(e) =>
                    setDraftKcData({ ...draftKcData, kc_mid: e.target.value })
                  }
                />
              </Form.Group>

              <Form.Group as={Col} md="3">
                <Form.Label htmlFor="crop-kc-late">{t("kc_late")}</Form.Label>
                <Form.Control
                  id="crop-kc-late"
                  type="number"
                  step="0.01"
                  placeholder={`${t("e_g")} 0.70`}
                  value={draftKcData.kc_late}
                  required
                  min="0.01"
                  onChange={(e) =>
                    setDraftKcData({ ...draftKcData, kc_late: e.target.value })
                  }
                />
              </Form.Group>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <OverlayTrigger
            placement="top"
            overlay={
              !cropData.is_kc_modified ? (
                <BsTooltip>
                  {"Kc values are already at default"}
                </BsTooltip>
              ) : (
                <></>
              )
            }
          >
            <span>
              <Button
                variant="outline-secondary"
                size="sm"
                disabled={!isKcsModified}
                onClick={() => {
                  setDraftKcData({ ...defaults });
                }}
              >
                {t("reset_kc")}
              </Button>
            </span>
          </OverlayTrigger>

          <Button
            variant="secondary"
            size="sm"
            type="button"
            onClick={() => setShowKcModal(false)}
          >
            {t("cancel") || "Cancel"}
          </Button>

          <Button
            variant="success"
            size="sm"
            type="button"
            onClick={() => {
              setCropData((prev) => ({
                ...prev,
                kc_init: draftKcData.kc_init,

                kc_mid: draftKcData.kc_mid,
                kc_late: draftKcData.kc_late,
                is_kc_modified: checkIfModified(draftKcData, defaults),
              }));
              setShowKcModal(false);
            }}
          >
            {t("confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    </main>
  );
}
